import React from 'react';
// import speed from './icon/speed.svg';
import conn from './icon/conn.svg';
import connyellow from './icon/conn-yellow.svg';
import connear from './icon/connear.svg';
import startConn from './icon/startConn.svg';
import endConn from './icon/endConn.svg';

import showbus from './icon/bus2.png';
import mylo from './icon/man.png';
import showNull from './icon/showNull.png';


var divStyle = {
    backgroundColor: 'white',
    borderRadius: '20px',
    width: '100%',    
    height: window.innerHeight-120,
    boxShadow: '5px 5px 10px #aaaaaa',
    // marginBottom:'8%'
  };

  var divHead = {
    color: 'white',
    backgroundColor: '#5c6bc0',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    paddingTop: '5px',
    textAlign:'center',
  };
  
  var divinFooter = {
    color: 'white',
    backgroundColor: '#7986cb',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    left:'0'
    // width: '150',
    //marginTop: '10px'
  };

  var divBody = {
    color: '#757575',
    backgroundColor: '#ffffff',
    // width: '150',
    height: window.innerHeight-205,
    overflowY: 'scroll',
  };


export default class Card extends React.Component {
    constructor(props) {
    super(props);
    this.state = { };
    this.alertStation = this.alertStation.bind(this);
    
  }

  alertStation(station){
      console.log('----',{station})

  }


  render() {

    const { value } = this.props
    const { result } = value
    const item = result
    let bus_line = ''
    let direction_name = ''
    let license_id = ''
    let speed =''

    if(item){
    
        bus_line = item['bus'].bus_line.replace("pothong_", "โพถ้อง ");
        speed = (item['bus'].speed).toFixed()
        license_id = item['bus'].license_id
        direction_name = item['stop_list'][0].bus_name

    var lis = [];
    const station = [];
    const predict = [];
    var nearest = 0;
    for(var j=0;j<item['stop_list'].length;j++){
        if(item['stop_list'][j].passed === false){    
            if(item['stop_list'][j].predict){
                if(item['stop_list'][j].predict >= 60 )
                    predict[j] = (item['stop_list'][j].predict/60).toFixed() + " น."
                else if(item['stop_list'][j].predict < 60 )
                    predict[j] = (item['stop_list'][j].predict).toFixed() + " ว."
            }        
            
            if(item['stop_list'][j].nearest_to_user){
                nearest = j
            }        
            
            station[j] = item['stop_list'][j].stop_name
        }
    }

    let startStopinExpand
    for(var k=0;k<item['stop_list'].length;k++){
        if(item['stop_list'][k].passed === false){
            startStopinExpand = item['stop_list'][k].stop_name
            // console.log({startStopinExpand})
            break;
        }
    }

    let ttConn='';
    let show='';

    for (var i=0; i<station.length; i++) {
        show=''
        if(station[i]){   

           

            if(i===0){
                ttConn=startConn; 
            }

            else if(i===(station.length-1)){
                ttConn=endConn; 
                if(show==='')show=showNull
            }

            else{
                if(i===nearest){
                    ttConn=connear;
                    show=mylo
                }
                else{
                    if(station[i] === startStopinExpand){
                        show = showbus
                        ttConn=connyellow;
                    }
                    else{
                        ttConn=conn;
                        if(show==='')show=showNull
                    }
                }
            }
        
            lis.push(
                <tbody key={i} >
                    <tr > 
                        <td style={{ textAlign:'center', width:'15%'}}> <span > {predict[i]} </span> </td>
                        <td style={{ textAlign:'center' }}>
                            <img height="50px" width="50px" src={ttConn} style={{ display:'block'}}  alt=""/>
                        </td>
                         <td onClick={this.alertStation.bind(station[i])} style={{cursor:'pointer' }}  > 
                            <span style={{marginLeft:'0px', align:'center' }} > {station[i]} </span>
                            <img height="30px" width="30px" src={show} />                            
                         </td>
                    </tr>
                </tbody>       
            );
        }
    }
        
}




    return (
        <div style={divStyle} >
           <div style={divHead}>
           <span style={{fontSize:'24px', }}>{bus_line} &nbsp;({license_id})</span>
                <br/>
                <span style={{ fontSize:'16px'}}> {direction_name} </span>
            </div>

            <div style={divBody} >
                <table cellSpacing='0' cellPadding='0' border='0' width='100%' style={{ borderCollapse:'collapse', fontSize:'16px', marginTop:'0px',marginLeft:'5px' }} >

                    {lis}

                </table>

            </div>
            
            <div style={divinFooter}>
                <div  style={{fontSize:'20px', display:'inline', marginLeft:'15px'}}> 
                {speed} กม./ชม.
            </div>
            </div>

        </div>
    );
  }
}    


// WEBPACK FOOTER //
// ./src/CardExpand.js